module.exports = __webpack_public_path__ + "static/media/pg14.2f1f351c.jpg";